// extracted by mini-css-extract-plugin
module.exports = {"item":"cd01fbf7b5--item--P8BSY"};